<style lang="less" scoped>
  .customer-selector{
    display: inline-block;
    width: 100%;
  }
  .customer-selector /deep/ .ivu-poptip{
    width: 100%;
  }
  .customer-selector /deep/ .ivu-poptip-inner{
    border-radius: 0;
  }
  .customer-selector /deep/ .ivu-poptip-rel{
    width: 100%;
  }
  .customer-selector /deep/ .ivu-poptip-body{
    padding: 0;
  }
  .select-customer{
    cursor: pointer;
    &:hover{
      background: #f5f5f5;
      .avatar{
        transform: scale(1.06);
      }
    }
  }
  .select-customer-disabled{
    color: #999;
    background: #f5f5f5;
    cursor: not-allowed;
  }
  .selector-btn{
    position: relative;
    padding-left: 8px;
    padding-right: 8px;
    text-align: left;
    .delete-btn{
      display: none;
    }
  }
  .selector-btn-deletable{
    padding-right: 25px;
    .delete-btn {
      transition: .1s;
    }
    &:hover {
      .delete-btn {
        display: inline-block;
        width: auto;
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translate(0, -50%);
        &:hover {
          transform: translate(0, -50%) scale(1.2, 1.2);
        }
      }
    }
  }
  .type-text{
    padding: 4px 6px;
    line-height: 1;
    border: none;
    &:focus{
      box-shadow: none;
    }
  }
  .search-area /deep/ input{
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
  }
  .search-area /deep/ .ivu-input-group-append{
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    background: transparent;
  }
  .select-customer-container{
    margin-top: 5px;
    height: 160px;
    overflow: auto;
  }
  .avatar-wrapper{
    display: inline-block;
    vertical-align: middle;
    width: 60px;
    height: 60px;
    overflow: hidden;
    .avatar{
      width: 100%;
      height: 100%;
      transition: transform .25s ease;
      will-change: transform;
    }
  }
</style>
<template>
  <div
    class="customer-selector"
    :style="{width: long ? '100%' : 'auto'}"
  >
    <Poptip
      v-if="searchable"
      placement="bottom"
      :width="width"
      :transfer="transfer"
      @on-popper-show="poperShow"
    >
      <Button
        class="selector-btn"
        :class="{'type-text': type === 'text', 'selector-btn-deletable': deletable ||clearable }"
        :type="type"
        :size="size"
        :long="long"
        :icon="icon"
        :disabled="disabled"
        :loading="initing"
      >
        <slot>
          <span v-if="selected_customer.id">{{ selected_customer.account }}</span>
          <span
            v-else
            class="color-grey"
          >
            {{ placeholder }}
          </span>
        </slot>
        <div 
          v-if="clearable"
          class="delete-btn"
        >
          <Icon
            type="md-close"
            @click.native.stop="delCustomer"
          />
        </div>
        <Poptip
          v-if="deletable"
          class="delete-btn"
          title="你确定要删除吗?"
          confirm
          @click.native.stop=""
          @on-ok="delCustomer"
        >
          <Icon type="md-close" />
        </Poptip>
      </Button>
      <div
        v-show="!disabled"
        slot="content"
        class="pop-tip-content"
      >
        <i-input
          v-model="search_text"
          class="search-area"
          search
          placeholder="搜索用户..."
          @on-search="searchCustomer"
        />
        <div
          v-if="loading"
          class="text-center"
        >
          <Spin fix />
        </div>
        <div class="select-customer-container">
          <div
            v-for="customer in customers"
            :key="customer.id"
            class="select-customer"
            :class="{'select-customer-disabled': customer.id === value}"
            @click="setCustomer(customer)"
          >
            <slot
              name="customer"
              :customer="customer"
            >
              <div class="avatar-wrapper">
                <img
                  v-if="avatarUrl(customer)"
                  class="avatar"
                  :src="avatarUrl(customer)"
                  alt=""
                >
                <Icon
                  v-else
                  type="md-person"
                  size="60"
                  color="#e5e5e5"
                />
              </div>
              <!--<span>{{customer.uid}} - </span>-->
              <span>{{ customer.account }} - </span>
              <span>{{ customer.team_name }}</span>
            </slot>
          </div>
        </div>
      </div>
    </Poptip>
    <div v-else>
      <span v-if="selected_customer.id">{{ selected_customer.account }}</span>
      <span
        v-else
        class="color-grey"
      >-</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: Number
      },
      type: {
        type: String
      },
      size: {
        type: String
      },
      icon: {
        type: String
      },
      width: {
        type: [Number, String],
        default: 300
      },
      disabled: {
        type: Boolean,
        default: false
      },
      url: {
        type: String,
        default() {
          return this.$util.api.customer_select_search
        }
      },
      long: {
        type: Boolean,
        default: true
      },
      transfer: {
        type: Boolean,
        default: false
      },
      deletable: {
        type: Boolean,
        default: false
      },
      searchable: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: '选择员工'
      },
      clearable: {
        type: Boolean,
        default: false
      },
      formal: {
        type: Boolean,
        default: undefined
      },
      outParams: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        search_text: '',
        customers: [],
        loading: false,
        initing: false,
        selected_customer: {}
      }
    },
    computed: {
      //
    },
    watch: {
      value() {
        this.initCustomer();
      }
    },
    created() {
      this.initCustomer();
    },
    mounted() {
      //
    },
    methods: {
      poperShow() {
        if (this.customers.length === 0) {
          this.searchCustomer();
        }
      },
      initCustomer(retry_count = 0) {
        if (this.selected_customer && this.selected_customer.id) return;
        if (!this.value) return;
        if (this.initing) return;
        this.initing = true;
        this.$util.ajax.get(this.$util.api.find_customer, {
          params: {
            id: this.value
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.selected_customer = data.customer;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.initing = false;
          // 失败重试
          if (!this.selected_customer.id && retry_count < 3) {
            this.initCustomer(retry_count + 1);
          }
        });
      },
      searchCustomer() {
        if (this.loading) return;
        const params = this.outParams || {}
        this.loading = true;
        this.$util.ajax.get(this.url, {
          params: {
            ...params,
            search: this.search_text,
            formal: this.formal,
            
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.customers = data.customers;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      setCustomer(customer) {
        this.selected_customer = customer;
        this.$emit('input', customer.id);
        this.$emit('on-change', customer);
        document.body.click();
      },
      delCustomer() {
        this.selected_customer = {};
        this.$emit('input', 0);
        this.$emit('on-change', {});
        this.$emit('on-delete');
      },
      avatarUrl(customer) {
        if (customer.candid_photo) {
          return customer.candid_photo;
          // return this.$util.publicOSSUrl(customer.candid_photo) + '?x-oss-process=style/avatar';
        } else if (customer.avatar) {
          return customer.avatar;
          // return this.$util.avatarUrl(customer.avatar);
        }
        return false;
      }
    }
  }
</script>
